import { AddMetadata, BlockKeys } from '../BlockCatalog';
import { BlockParameters, PipelineBlock } from '../PipelineBlock';
import { PipelineStage } from '../Stage';
import IndexThresholdStage, { IndexStageParameters } from '../stages/filters/IndexThreshold';
import ValueThresholdStage, { ValueStageParameters } from '../stages/filters/ValueThreshold';
import SortStage from '../stages/preprocess/SortStage';

export type ThresholdParams = BlockParameters &
    IndexStageParameters &
    ValueStageParameters & {
        isValueMode: boolean;
    };

@AddMetadata({
    type: BlockKeys.Threshold,
    name: 'Threshold',
    description:
        'Filters the Sensor Points according to upper and lower % thresholds. The thresholds can be applied to the Sensor Points value (scalar or module), to the number of active Sensor Points, and globally on independently each horizontal level',
})
class ThresholdBlock extends PipelineBlock<ThresholdParams> {
    constructor(params: ThresholdParams, id?: string) {
        super(params, id);
    }

    protected defineStages(): PipelineStage<any>[] {
        const { isValueMode } = this.getParams();
        return [new SortStage(), isValueMode ? new ValueThresholdStage(this.getParams()) : new IndexThresholdStage(this.getParams())];
    }

    public override updateParams(params: Partial<ThresholdParams>): void {
        const prevParams = this.getParams();
        const isValueModeChanged = params.isValueMode !== undefined && params.isValueMode !== prevParams.isValueMode;

        super.updateParams(params);
        if (isValueModeChanged) this.updateStages();
    }
}

export default ThresholdBlock;
